module.exports = __webpack_public_path__ + "img/vis_17.729003af.jpg";